var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "simple-form flex col-2" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-1-5x" }, [
          _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.no))])
        ])
      ]),
      _vm._v(" "),
      _vm.goodsRecvVoucher.orderFlag
        ? _c("div", { staticClass: "form-group center" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-1-5x" }, [
              _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.orderNo))])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-1-5x" }, [
          _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.shipNo))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-1-5x" }, [
          _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.senderComName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-1-5x" }, [
          _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.senderContactName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(5),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-1-5x" }, [
          _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.senderContactTel))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-1-5x" }, [
          _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.returnTime))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(7),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-1-5x" }, [
          _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.buyerRecvAddr))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(8),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value width-1-5x" },
          [
            _c(
              "el-select",
              {
                staticClass: "fl",
                attrs: { placeholder: "请选择", clearable: true },
                model: {
                  value: _vm.goodsRecvVoucher.returnCause,
                  callback: function($$v) {
                    _vm.$set(_vm.goodsRecvVoucher, "returnCause", $$v)
                  },
                  expression: "goodsRecvVoucher.returnCause"
                }
              },
              _vm._l(_vm.goodsReturnCauseList, function(item) {
                return _c("el-option", {
                  key: item.name,
                  attrs: { label: item.name, value: item.id }
                })
              })
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(9),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-1-5x" }, [
          _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.returnDesc))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(10),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-1-5x" }, [
          _vm.goodsRecvVoucher.returnAcceptState == 0
            ? _c("span", [_vm._v("未处理")])
            : _vm._e(),
          _vm._v(" "),
          _vm.goodsRecvVoucher.returnAcceptState == 1
            ? _c("span", [_vm._v("已接受")])
            : _vm._e(),
          _vm._v(" "),
          _vm.goodsRecvVoucher.returnAcceptState == -1
            ? _c("span", [_vm._v("已拒绝")])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(11),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-1-5x" }, [
          _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.returnHandleDesc))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(12),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-1-5x" }, [
          _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.returnHandlerName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(13),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-1-5x" }, [
          _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.returnLogisExpNo))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(14),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-1-5x" }, [
          _c("span", [_vm._v(_vm._s(_vm.goodsRecvVoucher.returnLogisComName))])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-form",
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.goodsRecvVoucher.goodsRecvVoucherItemList,
                  border: "",
                  "tooltip-effect": "dark"
                }
              },
              [
                _vm.showAssetInfo
                  ? _c(
                      "el-table-column",
                      { attrs: { align: "center", label: "资产信息" } },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            width: "130",
                            prop: "devcName",
                            label: "名称",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            width: "100",
                            prop: "devcCatName",
                            label: "分类",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            width: "100",
                            prop: "devcBrandName",
                            label: "品牌",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            width: "130",
                            prop: "devcModel",
                            label: "型号",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            width: "130",
                            prop: "devcFixedSpec",
                            label: "规格",
                            "show-overflow-tooltip": ""
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showAssetInfo
                  ? _c(
                      "el-table-column",
                      { attrs: { align: "center", label: "商品信息" } },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            width: "130",
                            prop: "title",
                            label: "名称",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            width: "100",
                            prop: "catName",
                            label: "分类",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            width: "100",
                            prop: "brandName",
                            label: "品牌",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            width: "130",
                            prop: "model",
                            label: "型号",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            width: "130",
                            prop: "fixedSpec",
                            label: "规格",
                            "show-overflow-tooltip": ""
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showAssetInfo
                  ? _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "title",
                        label: "名称",
                        width: "150",
                        "show-overflow-tooltip": ""
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showAssetInfo
                  ? _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "120",
                        prop: "catName",
                        label: "分类",
                        "show-overflow-tooltip": ""
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showAssetInfo
                  ? _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "100",
                        prop: "brandName",
                        label: "品牌",
                        "show-overflow-tooltip": ""
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showAssetInfo
                  ? _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "130",
                        prop: "model",
                        label: "型号",
                        "show-overflow-tooltip": ""
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showAssetInfo
                  ? _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "130",
                        prop: "fixedSpec",
                        label: "规格",
                        "show-overflow-tooltip": ""
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "asmblAccFlag",
                    label: "组装件",
                    width: "60",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.asmblAccFlag
                            ? _c("span", [_vm._v("是")])
                            : _c("span", [_vm._v("否")])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "setupFlag",
                    label: "需要安装",
                    width: "80",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.setupFlag
                            ? _c("span", [_vm._v("是")])
                            : _c("span", [_vm._v("否")])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "asmblFlag",
                    label: "含组装商品",
                    width: "80",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.asmblFlag
                            ? _c("span", [_vm._v("是")])
                            : _c("span", [_vm._v("否")])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "quantity",
                    label: "退货数量",
                    width: "100",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "desc",
                    label: "描述",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "操作",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.assetType == 0
                            ? _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.returnGoods(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("退货明细")]
                              )
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("退货单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("订单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发货单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发货机构")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发货人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("联系方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("退货时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("退货地址")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("退货原因")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("退货原因说明")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("退货受理状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("退货受理意见")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("退货受理人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("物流单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("物流公司名称")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7dffb006", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dffb006","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/GoodsReturnVoucherInfo.vue
// module id = 2949
// module chunks = 0